export const environment = {
  production: false,
  version: '1.0.3',
  apiUrl: 'your-api-url.com',
  
  firebase: {
    apiKey: "AIzaSyCDv8f54fvzWSUpf3D3Bu7s_qRGDtF4beg",
    authDomain: "projetobase-26ddc.firebaseapp.com",
    projectId: "projetobase-26ddc",
    storageBucket: "projetobase-26ddc.appspot.com",
    messagingSenderId: "72141612461",
    appId: "1:72141612461:web:e2f12583590b2312b7ad24",
    measurementId: "G-T1FCKLJ304"
  }
};